import type { ParsedAddress } from "./address-types";
import { GOOGLE_CITY_FALLBACK_COMPONENT_TYPES } from "@shared/formats/city";

export function parseGooglePlace(place: google.maps.places.Place): {
  parsed: ParsedAddress;
  display: string;
} {
  const components = place.addressComponents ?? [];
  let streetNumber = "";
  let route = "";
  let stateName = "";
  let state = "";
  let zip = "";
  let country = "";

  const CITY_TYPES_BY_PRIORITY: readonly string[] =
    GOOGLE_CITY_FALLBACK_COMPONENT_TYPES;
  let city = "";
  let cityPriority = CITY_TYPES_BY_PRIORITY.length;

  for (const component of components) {
    const type = component.types[0];
    if (type === "street_number") streetNumber = component.longText ?? "";
    else if (type === "route") route = component.longText ?? "";
    else if (type === "administrative_area_level_1") {
      stateName = component.longText ?? "";
      state = component.shortText ?? "";
    } else if (type === "postal_code") zip = component.longText ?? "";
    else if (type === "country") country = component.shortText ?? "";

    for (const candidateType of component.types) {
      const priority = CITY_TYPES_BY_PRIORITY.indexOf(candidateType);
      if (priority !== -1 && priority < cityPriority && component.longText) {
        city = component.longText;
        cityPriority = priority;
      }
    }
  }

  const line1 = streetNumber ? `${streetNumber} ${route}` : route;
  const lat = place.location?.lat();
  const lng = place.location?.lng();

  return {
    parsed: { line1, city, stateName, state, zip, country, lat, lng },
    display: place.formattedAddress ?? `${line1}, ${city}, ${state} ${zip}`,
  };
}
